// @flow
import * as React from 'react';
import { compose, withState } from 'recompose';
import Radium from 'radium';
import { Modal, ModalBody } from 'reactstrap';

import ENV from 'environment';
import { Colors, Sizes } from 'utils/styleguide';

type Props = {
  image: string,
  style?: Object,
  onDeleteClicked?: () => void,

  // recompose
  opened: boolean,
  onOpenedChange: (opened: boolean) => void,
  width: number,
  onWidthChange: (width: number) => void,
};

const WIDTH = 96;
const HEIGHT = 96;

class PreviewImage extends React.Component<Props> {
  _modal: ?Modal;

  constructor(props: Props) {
    super(props);
    this._modal = null;
  }

  _setModalRef = (ref: ?Modal) => {
    if (ref) {
      this._modal = ref;
    }
  };

  _onToggleModal = () => {
    const { opened, onOpenedChange, onWidthChange } = this.props;
    onOpenedChange(!opened);
    setTimeout(() => {
      if (!opened && this._modal) {
        // now opened
        onWidthChange(this._modal.clientWidth - 30);
      }
    }, 0);
  };

  render() {
    const { style, image, opened, width, onDeleteClicked } = this.props;
    const imageUrl = image.startsWith('https://')
      ? image
      : `${ENV.HOST}/images/${image}`;

    return (
      <div style={styles.root}>
        {/* <div
          style={[styles.image, { backgroundImage: `url(${imageUrl})` }, style]}
          onClick={this._onToggleModal}
        /> */}
        <img
          style={[styles.image]}
          src={imageUrl}
          height={HEIGHT}
          alt=""
          onClick={this._onToggleModal}
        />
        {!!onDeleteClicked && (
          <div style={styles.clear} onClick={() => onDeleteClicked()}>
            <span>&#x2A09;</span>
          </div>
        )}
        <Modal size="lg" isOpen={opened} toggle={this._onToggleModal}>
          <div ref={this._setModalRef}>
            <ModalBody>
              <img
                width={width}
                src={imageUrl}
                style={{ flexGrow: 1, flexShrink: 1 }}
              />
            </ModalBody>
          </div>
        </Modal>
      </div>
    );
  }
}

const styles = {
  root: {
    position: 'relative',
    // width: WIDTH,
    height: HEIGHT,
  },
  image: {
    // width: WIDTH,
    // height: HEIGHT,
    cursor: 'pointer',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: Colors.White,
    ':hover': {
      borderColor: Colors.LightGrey,
    },
  },
  clear: {
    borderRadius: '50%',
    backgroundColor: Colors.Black,
    color: Colors.White,
    fontWeight: 'bold',
    fontSize: 12,
    lineHeight: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: Sizes.Micro,
    height: Sizes.Micro,
    position: 'absolute',
    top: -Sizes.Micro / 2,
    right: -Sizes.Micro / 2,
    cursor: 'pointer',
    zIndex: 1000,
  },
};

const PreviewImageContainer = compose(
  withState('opened', 'onOpenedChange', false),
  withState('width', 'onWidthChange', 300),
  Radium,
)(PreviewImage);

export default PreviewImageContainer;



// WEBPACK FOOTER //
// ./src/components/PreviewImage/PreviewImage.js